// ComingSoon.jsx - Placeholder page for features under development
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, Rocket, Clock, Bell } from 'lucide-react';

export default function ComingSoon({ 
  title = "Coming Soon", 
  description = "We're working hard to bring you this feature. Stay tuned!",
  icon: Icon = Rocket,
  showNotify = true 
}) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 flex items-center justify-center px-4">
      <div className="max-w-2xl w-full">
        <div className="text-center">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl mb-8 animate-pulse">
            <Icon className="w-12 h-12 text-white" />
          </div>
          
          {/* Title */}
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {title}
          </h1>
          
          {/* Description */}
          <p className="text-xl text-slate-400 mb-8 max-w-lg mx-auto">
            {description}
          </p>
          
          {/* Progress Indicator */}
          <div className="flex items-center justify-center gap-3 mb-8">
            <Clock className="w-5 h-5 text-slate-500" />
            <span className="text-slate-500">Expected: Q1 2025</span>
          </div>
          
          {/* Email Notification (optional) */}
          {showNotify && (
            <div className="bg-slate-900/50 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-6 mb-8">
              <div className="flex items-center gap-3 mb-4 justify-center">
                <Bell className="w-5 h-5 text-blue-400" />
                <h3 className="text-white font-semibold">Get Notified</h3>
              </div>
              <p className="text-slate-400 text-sm mb-4">
                Want to know when this feature launches? We'll send you a quick email.
              </p>
              <div className="flex gap-3 max-w-sm mx-auto">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-1 px-4 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white placeholder-slate-500 focus:outline-none focus:border-blue-500"
                />
                <button className="px-6 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg font-semibold hover:from-blue-600 hover:to-purple-700 transition-all">
                  Notify Me
                </button>
              </div>
            </div>
          )}
          
          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center justify-center gap-2 px-6 py-3 bg-slate-800 text-white rounded-lg hover:bg-slate-700 transition-all"
            >
              <ArrowLeft className="w-5 h-5" />
              Go Back
            </button>
            <Link
              to="/dashboard"
              className="flex items-center justify-center px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg font-semibold hover:from-blue-600 hover:to-purple-700 transition-all"
            >
              Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

// Usage Examples for different pages:
// 
// For Documentation page:
// <ComingSoon 
//   title="Documentation" 
//   description="Comprehensive guides and API references coming soon"
//   icon={Book}
// />
//
// For Blog page:
// <ComingSoon 
//   title="Blog" 
//   description="Insights, tutorials, and updates from the CodeRated team"
//   icon={PenTool}
// />
//
// For Careers page:
// <ComingSoon 
//   title="Join Our Team" 
//   description="We're growing! Career opportunities coming soon"
//   icon={Users}
// />